module.exports = __webpack_public_path__ + "static/assets/climate-models-running-red-hot.0cad48b6.png";